export default __webpack_public_path__ + "static/media/GB.97c28a83.svg";